import { render } from "./InfoBlock.vue?vue&type=template&id=f3feccfc&ts=true"
import script from "./InfoBlock.vue?vue&type=script&lang=ts"
export * from "./InfoBlock.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__